import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { InputProps } from '.';
import Input from './Input';

/**
 * Component that renders a Reactstrap input
 *
 * @class TextBox
 * @extends {(React.Component<FieldRenderProps & InputProps>)}
 */
class NumberTextBox extends React.Component<FieldRenderProps<any, HTMLInputElement> & InputProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		return <Input {...this.props} type="number" />;
	}
}

export default NumberTextBox;
